export enum Section {
  DoctorVisit = 'DV',
  Medication = 'MEDICATION',
  Lab = 'LAB',
  Scan = 'SCAN',
}
